<template>
  <div class="home-dashboard-loglist-rework">
    <div class="home-dashboard-loglist-header">
      {{loglist_entry.project_name}}
    </div>
    <hr style="background: #333; border: none; color: #333; height: 1px; margin-left: 3%; margin-right: 3%">
    <div class="home-dashboard-loglist-content">
      <StandardDataField
        class="pa-1 home-dashboard-loglist-background-color"
        :header="`${loglist_entry.user} ${loglist_entry.created.substring(0, 16)}`"
        :value="loglist_entry.target === 'comment'?
                loglist_entry.value:
                `${loglist_entry.target} ${$t('Home.UserHome.Loglist.ActionSeperator')} ${loglist_entry.action}`"

        :readonly="true"
        width="100%"
        :style="`overflow: hidden ;text-overflow: ellipsis;
        white-space: nowrap; max-height: 45px;
        width: ${loglist_entry.work_package ? '82%' : '100%'};
        `"
        text_color="primary"
        />
        <TWorkPackage
            v-if="loglist_entry.work_package"
            style="margin-left: 3px"
            :workpackage_count="1"
            :zoom="1"
            :workpackage="loglist_entry.work_package"
            />
    </div>
  </div>
</template>

<script>
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue'
import TWorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue'
export default {
  components: {
    StandardDataField,
    TWorkPackage,
  },

  props: ['loglist_entry'],

}
</script>

<style>
.home-dashboard-loglist-rework {
  display: flex;
  flex-direction: column;
  /* gap: 3px; */
  /* margin: 5px; */
  background-color: var(--v-color-5-base);
  /* border: 3px; */
  border-radius: 3px;

}
.home-dashboard-loglist-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* padding: 5px; */
  /* top: 5px; */
  padding: 3px 3px 0px 3px;
  cursor: pointer;
}
.home-dashboard-loglist-header {
  display:flex;
  flex-direction: column;
  /* padding-top: 3px; */
  padding-left: 5px;
}

.home-dashboard-loglist-background-color {
  background-color: var(--v-color-5-base);
}
</style>
